export default __webpack_public_path__ + "static/media/coin1.b12931a8.svg";